export type BucketMigration<T> = (state: T) => T;

export abstract class BucketBase<T> {
    abstract readonly id: string;
    abstract readonly latestVersion: number;
    abstract getDefault(): T;
    abstract migrate(persisted: unknown, version?: number): T;

    protected abstract getMigrations(): Record<number, BucketMigration<T>>;

    protected applyMigrations(state: T, fromVersion: number): T {
        let next = state;
        const migrations = this.getMigrations();
        for (let version = fromVersion; version < this.latestVersion; version += 1) {
            const migrateStep = migrations[version + 1];
            if (migrateStep) {
                next = migrateStep(next);
            }
        }
        return next;
    }
}
